import type { User } from "@workos-inc/authkit-react";
import {
  deleteIdentity,
  getIdentity,
  putIdentity,
  type CachedIdentity,
} from "./db";

export type { CachedIdentity } from "./db";

/**
 * Map the WorkOS user shape into our `CachedIdentity` row. WorkOS uses
 * camelCase + nullable name fields; we mirror that exactly so we never lose
 * fidelity on round-trip.
 */
export function workOSUserToCachedIdentity(user: User): CachedIdentity {
  return {
    id: user.id,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    avatarUrl: user.profilePictureUrl,
    lastValidatedAt: Date.now(),
  };
}

export async function getCachedIdentity(): Promise<CachedIdentity | null> {
  const row = await getIdentity();
  return row ?? null;
}

export async function setCachedIdentity(user: User): Promise<CachedIdentity> {
  const identity = workOSUserToCachedIdentity(user);
  await putIdentity(identity);
  return identity;
}

export async function clearCachedIdentity(): Promise<void> {
  await deleteIdentity();
}
